var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircleFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Filled / Plus circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9996 14.4001C11.5342 14.4001 14.3996 11.5347 14.3996 8.0001C14.3996 4.46548 11.5342 1.6001 7.9996 1.6001C4.46498 1.6001 1.59961 4.46548 1.59961 8.0001C1.59961 11.5347 4.46498 14.4001 7.9996 14.4001ZM8.7996 5.6001C8.7996 5.15827 8.44143 4.8001 7.9996 4.8001C7.55778 4.8001 7.1996 5.15827 7.1996 5.6001V7.2001H5.59961C5.15778 7.2001 4.79961 7.55827 4.79961 8.0001C4.79961 8.44193 5.15778 8.8001 5.59961 8.8001H7.1996V10.4001C7.1996 10.8419 7.55778 11.2001 7.9996 11.2001C8.44143 11.2001 8.7996 10.8419 8.7996 10.4001V8.8001H10.3996C10.8414 8.8001 11.1996 8.44193 11.1996 8.0001C11.1996 7.55827 10.8414 7.2001 10.3996 7.2001H8.7996V5.6001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleFilled);
export default __webpack_public_path__ + "static/media/plus-circle-filled.44f55acab8bc7f720e0c8ec65d958596.svg";
export { ForwardRef as ReactComponent };